import type { CoinType } from '../stores/cointype/CoinTypeStore';

export const ONE_LINK_PARAMS_MAP: Record<string, string> = {
  utm_promo: 'deep_link_sub2',
  pc: 'deep_link_sub3',
  utm_source: 'deep_link_sub4',
  utm_campaign: 'deep_link_sub5',
  utm_feature: 'deep_link_sub6',
  game_id: 'deep_link_sub7',
  coin_type: 'deep_link_sub8',
  deep_link_value: 'deep_link_value',
};

export const getParam = (urlParams: URLSearchParams, key: string) => {
  return urlParams.get(key) || urlParams.get(ONE_LINK_PARAMS_MAP[key]) || null;
};

export const removeParam = (urlParams: URLSearchParams, key: string) => {
  urlParams.delete(key);
  urlParams.delete(ONE_LINK_PARAMS_MAP[key]);
};

// OX Agent: Input validation prevented — coin type allowlisted to GC/SC
export const parseCoinType = (value: string | null | undefined): CoinType | null => {
  const coinType = value?.toUpperCase();
  return coinType === 'GC' || coinType === 'SC' ? coinType : null;
};

// OX Agent: Input validation prevented — game id must be a positive integer
export const parseGameId = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }
  const gameId = Number(value);
  return Number.isSafeInteger(gameId) && gameId > 0 ? gameId : null;
};
